<script>
import LogNavBarContainer from '@/components/Log/LogNavBarContainer.vue';
import LogMonitorNotEnabled from '@/components/Log/LogMonitorNotEnabled.vue';
import LogTablesContainer from '@/components/Log/LogTablesContainer.vue';
import LogActionsBar from '@/components/Log/LogActionsBar.vue';
import LogQueryContainer from '@/components/Log/LogQueryContainer.vue';
import Loading from '@/rex-components/rex-loading.vue';
import LogGraph from '@/components/Log/LogGraph.vue';
import { LOGService } from '@/services/api/log.service';
import { mapState, mapGetters, mapMutations } from 'vuex';
import {
  VIEW_GROK_TAB_KEY,
  VIEW_SAVED_SEARCHES_TAB_KEY,
  LOG_PAGE_SIZE,
  DESC,
} from '@/components/Log/log.constants';
import { getRouteName } from '@/components/Log/log.types';
import { notificationError } from '@/utils/notification';

export default {
  components: {
    LogMonitorNotEnabled,
    LogNavBarContainer,
    LogTablesContainer,
    LogActionsBar,
    Loading,
    LogGraph,
    LogQueryContainer,
  },
  computed: {
    ...mapState('globalState/user', ['teamID']),
    ...mapGetters('globalState/settings', ['getDurationTime']),
    ...mapState('logState/logCommonState', [
      'sourceList',
      'isADType',
      'isSearchListEmpty',
    ]),
    ...mapGetters('logState/logCommonState', ['getCapabilityType']),
    showLogMonitorDocRedirect() {
      return (
        (!this.sourceList || this.sourceList.length === 0) &&
        !this.isSearchListEmpty &&
        !this.isLoading
      );
    },
    dispLogOrQueryTable() {
      return (
        (this.$route.query.currView !== VIEW_GROK_TAB_KEY &&
          this.$route.query.currView !== VIEW_SAVED_SEARCHES_TAB_KEY &&
          !(this.$route.query.queryExec?.length > 0)) ||
        this.$route.query.queryExec?.length > 0
      );
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    ...mapMutations('logState/logCommonState', ['setSourceList']),
    async fetchSources() {
      try {
        this.isLoading = true;
        const { data } = await LOGService.getSourcesList({
          team_id: this.teamID,
          capability: this.getCapabilityType,
          duration: this.getDurationTime,
          limit: LOG_PAGE_SIZE,
          offset: 1,
          order: DESC,
          searchKeyword: '',
        });
        const sources = data
          ? data.map((obj) => ({
              name: obj?.service_name,
              value: obj?.service_id,
              isGroup: obj?.is_group,
              color: obj?.is_group ? 'rgb(59, 191, 85)' : 'rgb(245, 150, 0)',
            }))
          : [];
        this.setSourceList(sources);
        if (
          sources.length > 0 &&
          !this.$route.query.source &&
          (this.$route.name === 'logPage' ||
            (this.isADType && this.$route.name === 'analyticsPage'))
        ) {
          this.$router.push({
            name: getRouteName(this.isADType),
            query: {
              ...this.$route.query,
              source: `${sources[0].value},${sources[0].name}`,
            },
          });
        }
        this.isLoading = false;
      } catch (error) {
        console.log('error', error);
        this.setSourceList([]);
        this.isLoading = false;
        error?.message?.toLowerCase()?.includes('timeout') &&
          notificationError(this.$t('log.timeoutErrMsg'));
      }
    },
  },
  mounted() {
    this.fetchSources();
  },
};
</script>

<template>
  <div :class="$style.logContainer">
    <LogMonitorNotEnabled v-if="showLogMonitorDocRedirect" />
    <div v-else-if="!isLoading">
      <LogQueryContainer />
      <LogActionsBar />
      <div :class="$style.logNavAndTable">
        <LogNavBarContainer
          :class="dispLogOrQueryTable && $style.navContainer"
        />
        <div :class="dispLogOrQueryTable && $style.tableGraphContainer">
          <LogGraph v-if="!isADType" />
          <LogTablesContainer />
        </div>
      </div>
    </div>
    <div v-if="isLoading" :class="$style.loaderBox">
      <Loading />
    </div>
  </div>
</template>

<style module>
.logContainer {
  display: flex;
  margin-top: 1rem;
  min-height: calc(100vh - 9rem);
}
.logNavAndTable {
  display: flex;
}
.navContainer {
  flex: 1;
}
.tableGraphContainer {
  flex: 4.7;
  margin-left: 0.875rem;
}
.loaderBox {
  width: 100%;
}
</style>
